import { remove as removeDiacritics } from 'diacritics';
import type { ValidationResult } from '../helpers/types';
import { formatValidationResponse } from '../helpers/utils';

const doesNotHaveForbiddenCharRegex = /^[ -~]*$/;
const noForbiddenCharMessage = 'Should not have forbidden chars (e.g. new line, tab, char, etc)';

export const validateNoForbiddenChar = (password: string): ValidationResult => {
  const isRuleValid = doesNotHaveForbiddenCharRegex.test(removeDiacritics(password));
  return formatValidationResponse(isRuleValid, noForbiddenCharMessage);
};
